
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.854 1.854l3.792 3.792a.5.5 0 00.708 0l3.792-3.792A.5.5 0 008.793 1H1.207a.5.5 0 00-.353.854z","fill":"currentColor","stroke":"currentColor","stroke-linejoin":"round"}})])
          )
        }
      }
    